import { useState, useEffect } from 'react';
import { Vehicle } from 'core/models/vehicle';
import { useVehicleRepository } from './useVehicleRepository';
import { Project } from 'core/models/project';
import { RTCTask } from 'core/models/rtc';

export function useVehicleRTCRequest(vehicleId: Vehicle.Id, projectId: Project.Id): RTCTask[] {
    const repository = useVehicleRepository();

    const [rtcTasks, setRTCTasks] = useState<RTCTask[]>(() => []);

    useEffect(() => {
        if (!repository) {
            return;
        }

        try {
            repository.addRTCRequestListener(vehicleId, projectId, setRTCTasks);

            return () => {
                repository.removeRTCRequestListener(vehicleId, projectId, setRTCTasks);
            };
        } catch (e) {
            console.error(`cannot start listening RTC request due to: ${JSON.stringify(e)}`);
            return () => { /* nothing to do */ };
        }
    }, [projectId, repository, vehicleId]);

    return rtcTasks;
}
